import { CartesianGrid, XAxis, YAxis, Label, Bar } from "recharts";
import { ChartData, CustomizedAxisTick, CustomizedBarLabel } from "../ChartUtil";
import BaseBarChart from "./BaseBarChart";
import { colorsLight } from "@coherehealth/common";

interface DueDatesProps {
  data: ChartData;
  yLabel: string;
  hourly?: boolean;
}

const DueDatesOverTimeChart = ({ data, yLabel, hourly }: DueDatesProps) => {
  return (
    <BaseBarChart data={data}>
      <CartesianGrid stroke="rgba(0, 0, 0, 0.08)" vertical={false} />
      <XAxis
        dataKey="name"
        axisLine={{ stroke: "rgba(0, 0, 0, 0.08)" }}
        tickLine={false}
        tick={(props) => <CustomizedAxisTick hourly={hourly} {...props} />}
        minTickGap={-200}
      />
      <YAxis
        dataKey="count"
        axisLine={{ stroke: "rgba(0, 0, 0, 0.08)" }}
        tickLine={{ stroke: "rgba(0, 0, 0, 0.08)" }}
        stroke={colorsLight.font.light}
        type="number"
        tickCount={4}
        interval={0}
        tick={{
          fontFamily: "Figtree, sans-serif",
          fontWeight: 600,
          fontSize: "15px",
          letterSpacing: "0px",
        }}
        domain={["auto", (dataMax: number) => Math.round(dataMax * 1.33)]}
      >
        <Label
          style={{
            textAnchor: "middle",
            fill: colorsLight.font.secondary,
            fontFamily: "Figtree, sans-serif",
            fontWeight: 600,
            fontSize: "15px",
            letterSpacing: "0px",
          }}
          angle={270}
          value={yLabel}
          position="insideLeft"
        />
      </YAxis>
      <Bar dataKey="count" fill="#02718B" label={CustomizedBarLabel} />
    </BaseBarChart>
  );
};

export default DueDatesOverTimeChart;
